import CalendarDCellSlot from "./CalendarDCellSlot";

import moment from "moment";

export default ({ time, selectedDate, events, onClickEvent, onClickSlot }) => {
  return (
    <div className="calendar-calendar-horas-ind">
      <div className="calendar-calendar-horas-ind-hora">
        <div className="calendar-calendar-horas-ind-hora-text">
          {moment(time, "HHmm").add(1, "hours").format("HH:mm")}
        </div>
        <div className="calendar-calendar-horas-ind-horas-separador"></div>
      </div>
      <div className="calendar-calendar-horas-ind-agenda">
        <div className="calendar-calendar-horas-ind-agenda-ind">
          <CalendarDCellSlot
            day={selectedDate}
            time={time}
            minute="00"
            events={events}
            onClickEvent={onClickEvent}
            onClickSlot={onClickSlot}
          />
          <CalendarDCellSlot
            day={selectedDate}
            time={time}
            minute="15"
            events={events}
            onClickEvent={onClickEvent}
            onClickSlot={onClickSlot}
          />
          <CalendarDCellSlot
            day={selectedDate}
            time={time}
            minute="30"
            events={events}
            onClickEvent={onClickEvent}
            onClickSlot={onClickSlot}
          />
          <CalendarDCellSlot
            day={selectedDate}
            time={time}
            minute="45"
            events={events}
            onClickEvent={onClickEvent}
            onClickSlot={onClickSlot}
          />
        </div>
      </div>
    </div>
  );
};
